var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelBucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0669 4.43306C16.311 4.67714 16.311 5.07286 16.0669 5.31694L4.81694 16.5669C4.57286 16.811 4.17714 16.811 3.93306 16.5669C3.68898 16.3229 3.68898 15.9271 3.93306 15.6831L15.1831 4.43306C15.4271 4.18898 15.8229 4.18898 16.0669 4.43306Z",
    fill: "#0B0C0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93306 4.43306C4.17714 4.18898 4.57286 4.18898 4.81694 4.43306L16.0669 15.6831C16.311 15.9271 16.311 16.3229 16.0669 16.5669C15.8229 16.811 15.4271 16.811 15.1831 16.5669L3.93306 5.31694C3.68898 5.07286 3.68898 4.67714 3.93306 4.43306Z",
    fill: "#0B0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelBucket);
export default __webpack_public_path__ + "static/media/del_bucket.9f84bac0ed89cccc154bf9df7494e2f8.svg";
export { ForwardRef as ReactComponent };